import React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Close, Menu } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveFund,
  setShowGimlaiMobile,
  setShowAmitMobile,
} from "../../state/actions/DashboardActions";
import { useHistory, useLocation } from "react-router-dom";
import UserFund from "../../entities/UserFund";
import { isEnterPress } from "../../utils/helpers/accessibilityUtil";
import wallet from "../../assets/images/black-wallet.png";
import greenDot from "../../assets/images/green-dot.png";
import grayDot from "../../assets/images/grey-dot.png";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { resetUser } from "../../state/actions/UserActions";
import { LogOut } from "../../services/LogOut";
import { useTranslation } from "react-i18next";
import "./Drawer.scss";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import DisconnectPopUp from "../DisconnectPopUp/DisconnectPopUp";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import { color } from "@mui/system";

const drawerWidth = 240;

export default function Drawerui() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation("common");
  const [isOpen, setIsOpen] = React.useState(false);
  const { userFunds,pensionTypeDescHeader } = useSelector((state: any) => state.UserReducer);

 
  const getFundIcon = (fund: UserFund) => {
    if (fund.isPensioner) {
      return wallet;
    } else {
      if (fund.isActiveFund) {
        return greenDot;
      }
      return grayDot;
    }
  };

  const handleFundClick = (fund: UserFund) => {
    dispatch(setActiveFund(fund));
    if (fund.isAmit) dispatch(setShowAmitMobile(true));
    else dispatch(setShowGimlaiMobile(true));
    if (location.pathname !== "/") {
      history.push("/");
    }
    setIsOpen(false);
  };

  const logOutPopUpHandler = () => {
    setIsOpen(false);
    dispatch(setModalState(true));
    dispatch(
      setModalChild(
        <DisconnectPopUp callbackDisconnect={logOut} center={true} size="m" />
      )
    );
  };

  const logOut = () => {
    dispatch(setModalState(false));
    dispatch(resetUser());
    dispatch(setActiveFund({} as UserFund));
    const refreshTokenNum = sessionStorage.getItem("refreshTokenNum");
    if (!refreshTokenNum) return;
    LogOut(refreshTokenNum);
  };

  const handleDrawerOpen = () => {
    setIsOpen(true);
  };

  const handleDrawerClose = () => {
    setIsOpen(false);
  };

  const fundDesc = (fund: UserFund) =>{
    return fund.isPensioner ? pensionTypeDescHeader && pensionTypeDescHeader[fund.fundCode] : `${t("Dashboard.pensionFund")}`      
   }

  return (
    <React.Fragment>



      < IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        //sx={{ mr: 2, ...(open && { display: 'none' }) }}
        onClick={handleDrawerOpen}
      >

        <Menu
          fontSize="medium"
          style={{ color: "#010203" }}
        // onClick={() => {
        //   setIsOpen(true);
        // }}
        />
      </IconButton>

      <Drawer
        anchor={"left"}
        open={isOpen}
        color="#010203"
        //variant="persistent"
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <Box sx={{ width: 190 }}>
          <div className="close-btn">
            <IconButton onClick={handleDrawerClose}>
              <Close/>
            </IconButton>
          </div>
          {userFunds?.length &&
            userFunds.map((fund: UserFund, index: number) => (
              <div
                className={`header-dropdown-item ${fund.isAmit && "pa-for-bigger-icons"
                  }`}
                key={index}
                onClick={() => handleFundClick(fund)}
                onKeyPress={(event) =>
                  isEnterPress(event) ? handleFundClick(fund) : null
                }
                tabIndex={0}
              >
                <img src={getFundIcon(fund)} alt="" />
                <div
                  className="header-dropdown-labels-wrapper"
                  style={{ marginRight: `${fund.isAmit ? "5px" : ""}` }}
                >                   
                  <span> {(localStorage.getItem("lang") === "he") ? fund.fundLabel : fund.fundNameArab}</span>
                  <span>{fundDesc(fund)}</span>
                </div>
              </div>
            ))}
          <div
            className="header-dropdown-item"
            onClick={logOutPopUpHandler}
            onKeyPress={(event) => (isEnterPress(event) ? logOutPopUpHandler() : null)}
            tabIndex={0}
          >
            <LogoutOutlinedIcon fontSize="small" />
            <div className="header-dropdown-labels-wrapper">
              <span>{t("general.logOut")}</span>
            </div>
          </div>
        </Box>
      </Drawer>
    </React.Fragment>
  );
}
